import React from "react"
import { Grid, Chip, Typography } from "@material-ui/core"

import {
	AccessTime as ClockIcon,
	PlayCircleOutline as ActuationIcon
} from "@material-ui/icons"

import { fullDatetime } from "@/utils/time"

import { AgentFormattedForList } from "@/services/AgentService"

import useStyles from "@/pages/Admin/Agent/AgentList/AgentListItem/AgentListDetails/styles"
import { colors } from "@/styles/colors"

export type AgentStatus = "enabled" | "disabled"

export type AgentStatusConfig = {
	statusLabel: string
	chipBackgroundColor: string
}

type AgentStatusTypeToAgentStatusConfig = Record<"enabled" | "disabled", AgentStatusConfig>

type AgentListDetailsProps = {
	agent: AgentFormattedForList
}

const AGENT_STATUS_TYPE_TO_AGENT_STATUS_CONFIG_PROPS: AgentStatusTypeToAgentStatusConfig = {
	disabled: {
		statusLabel: "Desativado",
		chipBackgroundColor: colors.red[100]
	},
	enabled: {
		statusLabel: "Ativado",
		chipBackgroundColor: colors.green[200]
	}
}

const AgentListDetails: React.FC<AgentListDetailsProps> = (props) => {
	const {
		agent
	} = props

	const classes = useStyles()

	const agentStatus: keyof typeof AGENT_STATUS_TYPE_TO_AGENT_STATUS_CONFIG_PROPS = agent.isActive ? "enabled" : "disabled"
	const agentStatusConfig = AGENT_STATUS_TYPE_TO_AGENT_STATUS_CONFIG_PROPS[agentStatus]

	const lastInvokedAtText = agent.lastInvokedAt ? fullDatetime(new Date(agent.lastInvokedAt)) : "Ainda não houve"

	return (
		<Grid container alignItems="center">
			<Grid item sm={12} md={5}>
				<Grid container justifyContent="center">
					<Chip
						label={agentStatusConfig.statusLabel}
						className={classes.chip}
						style={{
							backgroundColor: agentStatusConfig.chipBackgroundColor
						}}
					/>
				</Grid>
			</Grid>
			<Grid item sm={12} md={7}>
				<Grid container direction="column" spacing={1} alignItems="flex-start">
					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start" spacing={1}>
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ClockIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item>
								<Typography variant="body1" className={classes.listItemData}>Última alteração: {fullDatetime(new Date(agent.lastUpdatedAt))}</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Grid container alignItems="center" justifyContent="flex-start" spacing={1}>
							<Grid item>
								<Grid container alignItems="center" justifyContent="flex-start">
									<ActuationIcon className={classes.clockIcon} />
								</Grid>
							</Grid>
							<Grid item>
								<Typography variant="body1" className={classes.listItemData}> Último acionamento: {lastInvokedAtText}</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default AgentListDetails
